import { InternalDeliveryOverviewEntry } from 'api/model';

/**
 * Hardcoded facility ordering by company ID.
 * Facilities will be displayed in this order in the Internal Delivery Overview table.
 * Add company IDs in the desired display order.
 */
const FACILITY_ORDER: number[] = [5, 6, 9, 8, 14, 12, 10, 194, 94, 18, 13, 269, 7, 15, 16
  // Add company IDs here in the desired order
  // Example: 1, 5, 3, 2, 4
];

/**
 * Sorts facilities according to the hardcoded FACILITY_ORDER.
 * Facilities not in the list will appear at the end, sorted by company ID.
 */
const sortFacilitiesByOrder = (
  entries: InternalDeliveryOverviewEntry[]
): InternalDeliveryOverviewEntry[] => {
  return [...entries].sort((a, b) => {
    const aIndex = FACILITY_ORDER.indexOf(a.companyId);
    const bIndex = FACILITY_ORDER.indexOf(b.companyId);

    // If both are in the order list, sort by their position
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    // If only a is in the list, it comes first
    if (aIndex !== -1) {
      return -1;
    }

    // If only b is in the list, it comes first
    if (bIndex !== -1) {
      return 1;
    }

    // If neither is in the list, sort by company ID
    return a.companyId - b.companyId;
  });
};

export default sortFacilitiesByOrder;
